// extracted by mini-css-extract-plugin
export default {"ideas":"ideas_ideas__qUUZt","containerLoader":"ideas_containerLoader__jWwO8","bottom":"ideas_bottom__V319s"};